import { createContext } from "react";

type CodeChangesContextType = {
  collapsedGroups: Set<string>;
  toggleGroup: (id: string) => void;
};
export const CodeChangesContext = createContext<CodeChangesContextType | undefined>(undefined);
CodeChangesContext.displayName = "CodeChangesContext";
